export default __webpack_public_path__ + "static/media/pin-pickup.6fd58754.svg";